// src/js/helpers/notify.js
export default function installNotify() {
  if (typeof window.PlancNotify !== 'object') {
    window.PlancNotify = {
      show(message, type = 'info', timeout = 5000) {
        try {
          var n = document.createElement('div');
          n.className = 'planc-notice planc-notice-' + type + ' fixed top-4 right-4 z-50 max-w-sm bg-white border border-gray-200 rounded-lg shadow-lg p-4';
          n.innerHTML = '<div class="planc-notice-body">' + String(message) + '</div>';
          document.body.appendChild(n);
          setTimeout(function(){ try { n.remove(); } catch(e){ if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('PlancNotify.remove failed', e); } }, timeout);
        } catch (e) { if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('PlancNotify.show failed', e); }
      }
    };
  }
}
